import Alpine from 'alpinejs';
import 'htmx-ext-loading-states/dist/loading-states.esm.js';
import htmx from 'htmx.org';
import '../css/generated.css';
import { dialogClickListener } from './dialog-helpers';
import { keydownListenter } from './keyboard-helpers';
import { ProviderCarousel } from './provider-carousel';
import { ToastHandler } from './toast';
import { UserMenuHandler } from './user-menu';

(window as any).htmx = htmx;

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', dialogClickListener);
    document.addEventListener('keydown', keydownListenter);

    const toastHandler = new ToastHandler();
    toastHandler.globalInit();
    const flashDataEl = document.getElementById('flash-data');
    const toastFn = (window as any).toast as ((message: string, type?: 'info' | 'warning') => void) | undefined;
    if (flashDataEl && toastFn) {
        const success = flashDataEl.getAttribute('data-flash-success');
        const error = flashDataEl.getAttribute('data-flash-error');
        if (success) {
            toastFn(success, 'info');
        }
        if (error) {
            toastFn(error, 'warning');
        }
    }

    window.Alpine = Alpine;
    Alpine.data('toastHandler', () => toastHandler);
    Alpine.data('userMenuHandler', () => new UserMenuHandler());
    Alpine.data('providerCardCarousel', () => new ProviderCarousel());
    Alpine.start();
});
